import { Component, ViewChild } from '@angular/core';

import {
    AlertController, App, FabContainer, ItemSliding, List, ModalController, NavController, ToastController,
    LoadingController, Refresher, Tabs
} from 'ionic-angular';

/*
  To learn how to use third party libs in an
  Ionic app check out our docs here: http://ionicframework.com/docs/v2/resources/third-party-libs/
*/
// import moment from 'moment';

import { ConferenceData } from '../../../../providers/conference-data';
import { UserData } from '../../../../providers/user-data';
import {MissionsData} from "../../../../providers/missions-data";

import { SessionDetailPage } from '../../../session-detail/session-detail';
import { ScheduleFilterPage } from '../../../schedule-filter/schedule-filter';
import {MissionsMapPage} from "../../missions-map/missions-map";
import {MissionDetailPage} from "../../mission-detail/mission-detail";
import { MissionsCandidateDetailPage } from '../../missions-candidate/missions-candidate-detail/missions-candidate-detail';
import { MissionsCandidatePage } from '../../missions-candidate/mission-candidate-list/missions-candidate';
import {MissionsFilterPage} from "../../missions-filter/missions-filter";

import {AngularFireDatabase} from "angularfire2/database";



import {LocationSelectForm} from "../../../utils/location-select/location-select";
import {Geolocation} from "@ionic-native/geolocation";
import {MissionsListPage} from "../../missions-list/missions-list";
import {UiData} from "../../../../providers/ui-data";

declare var google: any;

@Component({
    selector: 'page-missions-contract-list',
    templateUrl: 'missions-contract-list.html'
})
export class MissionsContractListPage {
    // the list is a child of the schedule page
    // @ViewChild('scheduleList') gets a reference to the list
    // with the variable #scheduleList, `read: List` tells it to return
    // the List and not a reference to the element
    @ViewChild('scheduleList', { read: List }) scheduleList: List;
    segment: any = 'contracts';
    userInfos: any;
    dayIndex = 0;
    queryText = '';

    locationSelectModal: any;
    locationSelectModalInited: boolean = false;
    excludeTracks: any = [];
    shownSessions: any = [];
    groups: any = [];
    confDate: string;

    missions:any;
    locationAsked:boolean=false;

    empty: any = false;
    inited: any = false;
    loading: any = false;
    currently_loading: any = false;

    constructor(
        public alertCtrl: AlertController,
        public app: App,
        public loadingCtrl: LoadingController,
        public modalCtrl: ModalController,
        public navCtrl: NavController,
        public toastCtrl: ToastController,
        public userData: UserData,
        public uiData: UiData,
        public missionsData: MissionsData,
        public afDatabase: AngularFireDatabase,
        private geolocation: Geolocation
    ) {
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading){
            this.currently_loading = false;
            this.loading.dismiss();
        }
    }


    ionViewDidLoad() {


    }
    ionViewWillEnter(){

        this.getUserInfos();
    }
    getUserInfos() {

        var that = this;
        if(!this.inited) {
            this.inited=true;
            this.setLoading(true,'Chargement de vos informations ...');
        }
        this.missions = {};
        that.userData.userSession().subscribe(session => {
            if(session!==null)
            {
                that.userData.load().subscribe(user => {
                    //this.userData.checkLoggedIn(this.navCtrl,'MissionsListPage');
                    that.setLoading(false);
                    that.missions = that.missionsData.getUserMissionsContracts();
                    that.empty = (that.missions.visible.length ==0 );
                });
            }
        });

    }
    getStatusLabels(str="")
    {
        var statusLabels = {
            'in-progress': "En cours",
            'scheduled': "A venir",
            'closed': "Terminés",
            'canceled': "Annulées"
        };
        if(str!="")return statusLabels[str];
        return statusLabels;
    }
    getStatusIcons(str="")
    {
        var statusLabels = {
            'in-progress': "timer",
            'scheduled': "stopwatch",
            'closed': "checkmark-circle",
            'canceled': "cross"
        };
        if(str!="")return statusLabels[str];
        return statusLabels;
    }
    cancelMission(mission)
    {

    }
    goToMissionDetail(missionData: any) {
        // go to the session detail page
        // and pass in the session data
        this.navCtrl.push(MissionsCandidateDetailPage, { missionId: missionData.id, name: missionData.name });
    }
    gotoContracts() {
        // go to the session detail page
        // and pass in the session data

        this.navCtrl.setRoot(MissionsContractListPage);
    }
    gotoCandidates() {
        // go to the session detail page
        // and pass in the session data

        this.navCtrl.setRoot(MissionsCandidatePage);
    }
}



// WEBPACK FOOTER //
// ./src/pages/missions/missions-contract/missions-contract-list/missions-contract-list.ts